import { getHttpClient, VtManagementApi } from '@capsicum/common';

export const fanTokenOfferingApi = getHttpClient.then(c => new VtManagementApi(c));
